// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1d6Fj","rootNoMargin":"styles_rootNoMargin__YjF8Y"};